import { mergeRight } from 'ramda';
import { handleActions } from 'redux-actions';

import * as types from './actionTypes';

export const initialState = {
	filter: {
		tasksList: [],
		noFoundTasks: false,
	},
	quickFilterType: 'all',
	progress: null,
};

const resetFilter = (state) => {
	return {
		...state,
		filter: initialState.filter,
	};
};

const changeQuickFilter = (state, { payload: { type } }) => {
	return mergeRight(state, { quickFilterType: type });
};

const setTasks = (state, action) => {
	const { tasksList } = action.payload;
	return {
		...state,
		filter: {
			tasksList,
			noFoundTasks: !tasksList.length > 0,
		},
	};
};

const resetTasks = (state) => {
	return {
		...state,
		filter: {
			tasksList: [],
		},
	};
};

const reset = () => initialState;

const setProgress = (state, { payload }) => {
	return {
		...state,
		progress: payload.progressList,
	};
};

const completeProgress = (state) => {
	return {
		...state,
		progress: null,
	};
};

const tasksReducer = {
	[types.SET_TASKS]: setTasks,
	[types.RESET_TASKS]: resetTasks,
	[types.CHANGE_QUICK_FILTER]: changeQuickFilter,
	[types.RESET]: reset,
	[types.RESET_FILTER]: resetFilter,
	[types.SET_PROGRESS]: setProgress,
	[types.COMPLETE_PROGRESS]: completeProgress,
};

export default handleActions(tasksReducer, initialState);
